import React from 'react';
import { isAuthenticated } from "../../auth";
import { Route, Redirect } from "react-router-dom";
import PropTypes from 'prop-types';


import { Main as MainLayout, Minimal as MinimalLayout } from '../../layouts';

import {
  SignIn as SignInView,
} from '../../views';


const RouteWithLayout = props => {
  const { layout: Layout, component: Component, ...rest } = props;


  return (
    <Route
      {...rest}
      render={matchProps => (
        isAuthenticated() ? (
          <Layout>
            <Component {...matchProps} />
          </Layout>
        ) : (
            <Layout layout={MinimalLayout}>
              <Component component={SignInView}/>
                <Redirect to={{ pathname: "/login", }} />
            </Layout>

          )
      )}
    />
  );
};


RouteWithLayout.propTypes = {
  component: PropTypes.any.isRequired,
  layout: PropTypes.any.isRequired,
  path: PropTypes.string
};

export default RouteWithLayout;
